import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { AccountDto, LicenceDto } from '../dtos/dtos';

@Injectable({
  providedIn: 'root',
})
export class AccountService {
  private url = `${environment.apiUrl}/accounts`;
  private adminUrl = `${environment.apiUrl}/admin/accounts`;

  constructor(private http: HttpClient) {}

  get(perma: string): Observable<AccountDto> {
    return this.http.get<AccountDto>(`${this.url}/${perma}`);
  }

  //

  getAll(year?: number): Observable<AccountDto[]> {
    return this.http.get<AccountDto[]>(
      this.adminUrl,
      year == null
        ? {}
        : {
            params: { year },
          },
    );
  }

  create(account: AccountDto): Observable<void> {
    return this.http.post<void>(this.adminUrl, account);
  }

  update(perma: string, account: AccountDto): Observable<void> {
    return this.http.put<void>(`${this.adminUrl}/${perma}`, account);
  }

  delete(perma: string): Observable<void> {
    return this.http.delete<void>(`${this.adminUrl}/${perma}`);
  }

  getAllLicences(perma: string): Observable<LicenceDto[]> {
    return this.http.get<LicenceDto[]>(`${this.url}/${perma}/licences`);
  }
}
